import axios from '@/axios.js'
export default {

  addCreateSchedule({ commit }, item) {
    return new Promise((resolve, reject) => {
        axios.post('/api/schedule/createschedule', item)
          .then((response) => {
            commit('ADD_CREATESCHEDULE', Object.assign(item, {createScheduleId: response.data.data.createScheduleId, createdOn: response.data.data.createdOn }))
            resolve(response)
          })
          .catch((error) => { reject(error) })
    })
  },
  updateCreateSchedule({ commit }, item) {
    return new Promise((resolve, reject) => {
        axios.put('/api/schedule/createschedule', item)
          .then((response) => {            
            //console.log(response.data.data)
            commit('UPDATE_CREATESCHEDULE', item)
            resolve(response)
          })
          .catch((error) => { reject(error) })
    })
  },
  getAllCreateSchedule({commit}) {
    return new Promise((resolve, reject) => {
      axios.get('/api/schedule/createschedule')
          .then((response) => {
            commit('GET_ALL_CREATESCHEDULE',  response.data.data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
    })
  },
  getAllCreateScheduleById({commit}) {
    return new Promise((resolve, reject) => {
      axios.get('/api/schedule/createschedule')
          .then((response) => {
            commit('GET_ALL_CREATESCHEDULE',  response.data.data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
    })
  },
  
  // tempScheduleToLive({commit}) {
  //   return new Promise((resolve, reject) => {
  //     axios.get('/api/schedule/tempscheduletolive')
  //         .then((response) => {
  //           commit('TEMP_SCHEDULE_TO_LIVE',  response.data.data)
  //           resolve(response)
  //         })
  //         .catch((error) => { reject(error) })
  //   })
  // },
    
}